import React from 'react';
import { Button, Card } from '@avila-tek/ui/src';
import { useNotify } from '../../../hooks';
import { PaymentMethod } from '../../../models';

interface PaymentStepLayoutProps {
  children: React.ReactNode;
  title: string;
  num: number;
  collapsed: boolean;
  setStepSelected: React.Dispatch<React.SetStateAction<number>>;
  paymentMethod?: PaymentMethod;
  paymentReference?: string;
}

function PaymentStepLayout({
  children,
  title,
  num,
  collapsed,
  setStepSelected,
  paymentMethod,
  paymentReference = '',
}: PaymentStepLayoutProps) {
  const notify = useNotify();

  const nextStep = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    if (num === 1 && paymentMethod === null) {
      return notify('Seleccione un método de pago', 'error');
    }
    if (num === 2 && paymentReference === '' && !paymentMethod?.automated) {
      return notify('Ingrese el número de referencia', 'error');
    }
    setStepSelected((step) => Number(step + 1));
  };

  return (
    <Card className="p-5 cursor-pointer relative z-10">
      <div>
        <div className="flex items-center">
          <div className="w-8 h-8 bg-purple-300 rounded-md flex justify-center items-center text-white font-arial font-semibold">
            {num}
          </div>
          <span className="ml-3 font-arial font-semibold text-text-black">
            {title}
          </span>
        </div>
        {collapsed ? children : null}
        {collapsed ? (
          <div className="flex flex-col sm:flex-row gap-5">
            {num !== 1 ? (
              <Button
                className="mt-5 relative z-20 bg-white border border-purple-300 text-purple-300"
                onClick={(e) => {
                  e.preventDefault();
                  setStepSelected((step) => Number(step - 1));
                }}
              >
                Volver
              </Button>
            ) : null}
            {num !== 3 ? (
              <Button className="mt-5 relative z-20" onClick={nextStep}>
                Continuar
              </Button>
            ) : null}
          </div>
        ) : null}
      </div>
    </Card>
  );
}

export default PaymentStepLayout;
